import ResetPasswordComponent from '@/views/PasswordReset.vue';
import RouteNames from '../constants/route-names';

const resetPasswordRoute = {
  component: ResetPasswordComponent,
  name: RouteNames.PasswordReset,
  path: '/password/reset',
  props: route => ({
    personId: route.query.id,
    token: route.query.token,
  }),
};

export default resetPasswordRoute;
